import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

export default function AboutOne() {
    return (
        <Container>
            <Row>
                <Col className='about-one-title' > About Us </Col>
            </Row>
            <Row className='text-center' >
                <Col>
                    <h3 className='about-one-h'> Security solutions for your work and home. </h3>
                </Col>
            </Row>
            <Row >
                <Col className='text-center'>
                    <p className='about-one-p text-center' >
                        Security camera installation can be complicated. Royality Technologies will provide all your security needs with advanced security solutions. We are the most efficient company at providing security camera installations and services. Our company is one of the leading supply chains of Surveillance systems / Biometric / Surveillance Cameras in Hyderabad.
                    </p>
                    <p className='about-one-p text-center'>
                        Royality Technologies believes in quality work and client satisfaction. With years of experience, we are proud of our services in the security field for installing CCTV Home Security Cameras: Dome, IP, IP Bullet, Wi-Fi CCTV and Biometric. Royality Technologies is your one-stop shop for anything related to security solutions.
                    </p>
                </Col>
            </Row>
            <Row className='text-center mt-5' >
                <Col>
                    <h3 className='about-one-h'> Vision, Mission and Values </h3>
                </Col>
            </Row>
            <Row className='justify-content-center mt-3 mb-5' >
                <Col xl={6} xs={12} sm={12} >
                    <img className='about_img' src='/images/home/about1.jpg' alt='Loading..' />
                </Col>
                <Col className='about-one-col mt-3' xl={6} xs={12} sm={12}>
                    <h3> Vision </h3>
                    <p> We believe quality is the most important characteristic of any security product or CCTV Security System. Our vision is inspired by our reputation among customers and service quality standards. It is true to say that we are one of the best CCTV security camera systems, surveillance cameras, biometrics dealers and providers in Hyderabad. Our prime concern is to address and meet all our customers’ needs and standards. Customer satisfaction is our prime goal rather than accounting for profits. </p>
                    <h3> Mission </h3>
                    <p> Our mission is to provide superior quality security services that customers recommend to family and friends and help us create long-term bonds with them. Our company excels in providing efficient CCTV home security systems and CCTV installation services at affordable prices and timely services. We have unparalleled experience in providing and servicing safety and security products for domestic, commercial, and industrial sectors, which leads to the growth of a good reputation for security systems among our customers. </p>
                    <h3> Values </h3>
                    <p> Our business values are the principles that we stand for. They are- customer service, integrity, commitment, perseverance, determination, innovation and respect.  </p>
                </Col>
            </Row>
        </Container>
    )
}
